import { GeoShapeRenderer } from '@leverege/molten/data-viewers';
import { ZoneVehicleModel } from "./renderers/index.js";
import ZoneVehicleEditor from "./renderers/ZoneVehicleEditor.js";
import ZoneVehicleLoaderLayer from "./renderers/ZoneVehicleLoaderLayer.js";
import GroupingSelectionListener from "./listeners/GroupingSelectionListener.js";
import CaseHistoryModel from "./models/CaseHistoryModel.js";
import CaseHistoryEditor from "./editors/CaseHistoryEditor.js";
import SymbolizerSetup from "./symbolizers/PluginSetup.js";
import FilterableZoneGeoShapeEditor from "./renderers/FilterableZoneGeoShapeEditor.js";
import FilterableZoneGeoShapeModel from "./renderers/FilterableZoneGeoShapeModel.js";
import FilterableZoneGoogleMapsRendererCreator from "./renderers/FilterableZoneGoogleMapsRendererCreator.js";
export default {
  install(molten) {
    molten.addPlugin('Model', {
      type: ZoneVehicleModel.TYPE,
      model: ZoneVehicleModel
    });
    molten.addPlugin('ModelEditor', {
      type: ZoneVehicleModel.TYPE,
      editor: ZoneVehicleEditor
    });
    molten.addPlugin('MapBoxLayerRenderer', {
      type: ZoneVehicleModel.TYPE,
      layerRenderer: ZoneVehicleLoaderLayer
    });
    molten.addPlugin('Model', {
      type: CaseHistoryModel.TYPE,
      model: CaseHistoryModel
    });
    molten.addPlugin('ModelEditor', {
      type: CaseHistoryModel.TYPE,
      editor: CaseHistoryEditor
    });
    GroupingSelectionListener.install();
    SymbolizerSetup.install(molten);
    molten.addPlugin('Model', {
      type: FilterableZoneGeoShapeModel.TYPE,
      model: FilterableZoneGeoShapeModel
    });
    molten.addPlugin('ModelEditor', {
      type: FilterableZoneGeoShapeModel.TYPE,
      editor: FilterableZoneGeoShapeEditor
    });
    molten.addPlugin('MapBoxLayerRenderer', {
      type: FilterableZoneGeoShapeModel.TYPE,
      layerRenderer: GeoShapeRenderer
    });
    molten.addPlugin('Molten.blueprintRelationshipProcessor', FilterableZoneGoogleMapsRendererCreator);
  }
};